

















































































































































// @ts-nocheck

import Vue from "vue"
import {pr} from "@/helpers/functions"
import apidb from "@/providers/apidb"
import apiip from "@/providers/apiip"
import apiflag from "@/providers/apiflag"

import {get_obj_entity, config} from "@/modules/iprequest/queries"
import {get_requests_by_ip, get_requests_per_day, get_requests_per_hour, get_into_blacklist, get_requests_per_min, get_requests_per_sec} from "@/modules/iprequest/queries_detail"
import get_filters from "@/helpers/filter"

import progressbar from "@/components/common/bars/progress_bar.vue"
import notisuccess from "@/components/common/notifications/notification_success.vue"
import notierror from "@/components/common/notifications/notification_error.vue"
import noticonfirm from "@/components/common/notifications/notification_confirm.vue"

export default Vue.extend({

  name: "iprequest-detail",

  components:{
    progressbar,
    notisuccess,
    notierror,
    noticonfirm,
  },

  props:{
    //si se muestra el form
    isvisible: Boolean,
    objrow: Object,
  },

  data: ()=>(
    {
      isconfirm: false,
      issubmitting: false,
      error: {title:"",message:""},
      success: {title:"",message:""},
      objrowform: {},
      objflag: {},
      requestsby:{
        ip:[],
        day:[],
        hour:[],
        min:[],
        sec:[],
      },
      blockdate:{
        full: "",
      }
    }
  ),

  //getters
  computed:{
    
    get_dialogtitle(): string {return `Nº:${this.objrowform.id} - IP: ${this.objrowform.remote_ip}`},

    is_visible:{
      get(): boolean { return this.isvisible},
      set(v: any){}
    },

    is_submitting(){return this.issubmitting},

  },
  
  created(){
    console.log("detail.creatd",this.objrow)
    this.objrowform = {...this.objrow}
    ;this.async_refresh()
  },

  watch:{
    isvisible: function(curr,old){
      if(curr==true){
        this.objrowform = {...this.objrow}
        ;this.async_refresh()
      }
      console.log("detail.watch.isvisible",this.objrowform)
    }
  },

  //setters 
  methods:{

    get_blockdate(format="full"){
      //pr(this.blockdate.full,"full")
      if(!format || format==="full") return this.blockdate.full
      if(format=="day") return (this.moment(this.blockdate.full).format("YYYY-MM-DD"))
      if(format=="hour") return (this.moment(this.blockdate.full).format("YYYY-MM-DD HH"))
      if(format=="min") return this.moment(this.blockdate.full).format("YYYY-MM-DD HH:mm")
      if(format=="sec") return this.moment(this.blockdate.full).format("YYYY-MM-DD HH:mm:ss")
      return this.moment().format("YYYYMMDD hmmss")
    },

    set_objrowform(objrow){
      this.objrowform = {...objrow}
      this.blockdate.full = this.objrowform.bl_date
    },

    set_error(title,message){
      this.error.title = title
      this.error.message = message
    },

    set_success(title,message){
      this.success.title = title
      this.success.message = message
    },    

    reset_alerts(){
      this.set_error("","")
      ;this.set_success("","")
    },

    close(){
      console.log("detail.close.close",this.objrowform)
      this.objrowform = {}
      this.objflag = {}
      ;this.reset_alerts()
      ;this.$emit("evtclose")
    },

    show_confirm(){
      this.isconfirm = true
    },

    async_refresh: async function (){
      this.reset_alerts()
      this.issubmitting = true

      const objparam = {
        filters:{
          op: "AND",
          fields:[{field:"r.id", value:this.objrowform.id}]
        }
      }

      const objquery = get_obj_entity(objparam)
      const result = await apidb.async_get_list(objquery)

      const objq1 = get_requests_by_ip(this.objrowform.remote_ip)
      const r1 = await apidb.async_get_list(objq1)
      this.requestsby.ip = r1.result

      const objq2 = get_requests_per_day(this.objrowform.remote_ip)
      const r2 = await apidb.async_get_list(objq2)
      this.requestsby.day = r2.result

      const objq3 = get_requests_per_hour(this.objrowform.remote_ip)
      const r3 = await apidb.async_get_list(objq3)
      this.requestsby.hour = r3.result

      const objq4 = get_requests_per_min(this.objrowform.remote_ip)
      const r4 = await apidb.async_get_list(objq4)
      this.requestsby.min = r4.result

      const objq5 = get_requests_per_sec(this.objrowform.remote_ip)
      const r5 = await apidb.async_get_list(objq5)
      this.requestsby.sec = r5.result

      //pr(r3,"R3")
      const flag = await apiflag.async_getflags([this.objrowform])
      this.objflag = {...flag[0]}

      this.issubmitting = false
      if(result.error){
        this.set_error("Error",result.error)
        ;this.$emit("evtrefresh","nok")
        return
      }

      if(!result.result[0]){
        this.set_error("Error","No result")
        ;this.$emit("evtrefresh","nok")
        return
      }

      ;this.set_objrowform(result.result[0])
      ;this.set_success("Success",`Reg refreshed ${this.objrowform.id}`)
      ;this.$emit("evtrefresh","ok")
    },// async

    async_ban: async function (option){
      this.isconfirm = false
      //pr(option)
      if(option!=="accept") return

      const objq = get_into_blacklist({remote_ip:this.objrowform.remote_ip,reason:"manual suspicious"})
      const r = await apidb.async_insert(objq)
      ;this.async_refresh()
    }
  }
})
